import React from 'react';
import '../styles/HowToPlay.css';

const HowToPlay = () => {
  return (
    <div className="howtoplay-page">
      <h2>How to Play Go</h2>
      
      <p className="lead">
        Go is a strategic board game for two players. The rules are simple to learn, but the game offers endless depth and challenge.
      </p>
      
      <section className="video-section">
        <h3>Learn the Basics</h3>
        <p>Watch this excellent tutorial from Go Magic to learn how to play Go:</p>
        
        <div className="video-container">
          <iframe 
            width="560" 
            height="315" 
            src="https://www.youtube.com/embed/oZTdT8MQexk?si=ML23-XoMJKbhQ1ts" 
            title="YouTube video player" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerPolicy="strict-origin-when-cross-origin" 
            allowFullScreen
          />
        </div>
      </section>

      <section className="recommended-resources mt-5">
        <h3>Want to Learn More?</h3>
        <p>
          The best way to learn Go is to play! Visit our club meetings where experienced players can teach you the game.
        </p>
        <p>
          You can also try playing online at sites like <a href="https://online-go.com/" target="_blank" rel="noopener noreferrer">OGS</a> or <a href="https://www.gokgs.com/" target="_blank" rel="noopener noreferrer">KGS</a>, which offer tutorials and matches against players of all skill levels.
        </p>
      </section>

    </div>
  );
};

export default HowToPlay; 